import React from 'react';
import { Skeleton, IconButton, Flex } from '@landr/maestro';
import { getIconWithTooltipBySampleType } from 'helpers';
import { defaultRowContainer } from '../SamplesTablePlayer/SamplesTablePlayer.styled';
import { SamplesTableTypeIconProps } from './SamplesTableTypeIcon.types';
import { typeIconButton } from './SamplesTableTypeIcon.styled';

export const SamplesTableTypeIconSkeleton = () => (
    <Flex className={defaultRowContainer}>
        <Flex width="sm">
            <Skeleton width="xs" height="xs" />
        </Flex>
    </Flex>
);

export const SamplesTableTypeIcon: React.FC<SamplesTableTypeIconProps> = ({
    sampleType,
}) => {
    const { Icon: SampleTypeIcon, tooltip } =
        getIconWithTooltipBySampleType(sampleType);

    return (
        SampleTypeIcon && (
            <IconButton
                className={typeIconButton}
                kind="link"
                color="text.medium"
                size="sm"
                label={tooltip}
                icon={SampleTypeIcon}
                marginTop="2px"
                paddingLeft="none"
                minWidth="auto"
            />
        )
    );
};
